import React from 'react';
import { motion } from 'framer-motion';
import { FaLock, FaCrown } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

const LockedContent: React.FC = () => {
  const navigate = useNavigate();

  return (
    <motion.div 
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="min-h-[calc(100vh-160px)] w-full flex items-center justify-center"
    >
      <div className="absolute inset-0 bg-black/40 backdrop-blur-md" />

      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="relative w-full max-w-2xl mx-auto p-8 text-center"
      >
        <div className="mx-auto max-w-xl rounded-2xl border border-white/10 bg-white/5 backdrop-blur-sm p-8">

        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: 0.2, type: "spring", stiffness: 200 }}
          className="relative mx-auto mb-6 h-16 w-16"
        >
          {/* Glow effect */}
          <div className="absolute inset-0 rounded-full bg-blue-500/30 blur-xl animate-pulse" />
          <div className="relative flex h-16 w-16 items-center justify-center rounded-full bg-gradient-to-br from-blue-500 to-purple-600">
            <FaLock className="text-white w-7 h-7" />
          </div>
        </motion.div>

        <motion.h2
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.3 }}
          className="text-2xl font-bold text-white mb-4"
        >
          Membership Inactive
        </motion.h2>

        <motion.p
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.4 }}
          className="text-gray-300 mb-6 max-w-md"
        >
          This page is available to active members only. Please contact support if you believe your membership should be active.
        </motion.p>

        <motion.div
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.5 }}
          className="space-y-4"
        >
          <button
            onClick={() => navigate('/dashboard/support')}
            className="mx-auto px-6 py-3 bg-gradient-to-r from-blue-500 to-purple-600 text-white rounded-lg font-medium flex items-center justify-center space-x-2 hover:from-blue-600 hover:to-purple-700 transition-all duration-200 shadow-lg hover:shadow-xl group"
          >
            <FaCrown className="w-5 h-5 transform group-hover:scale-110 transition-transform" />
            <span>Contact Support</span>
          </button>
          
          <div>
            <button
              onClick={() => navigate('/dashboard')}
              className="text-gray-400 hover:text-white transition-colors duration-200"
            >
              Return to Dashboard
            </button>
          </div>
        </motion.div>
        </div>
      </motion.div>
    </motion.div>
  );
};

export default LockedContent;
